import script from "./tenant-switching-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./tenant-switching-modal.vue?vue&type=script&setup=true&lang=ts"

import "./tenant-switching-modal.vue?vue&type=style&index=0&id=1ca2db02&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca2db02"]])

export default __exports__